import { memo } from 'react'

import moment from 'moment'

import { Box, ListItem, ListItemText } from '@mui/material'

import { TrainingMaterialBaseResponse } from '@tabeeb/contracts/microservices/swagger-article-service'

import TrainingMaterialLinkButton from '../TrainingMaterialLinkButton'

export interface TrainingMaterialListItemProps {
  disabled?: boolean
  item: TrainingMaterialBaseResponse
  children?: React.ReactNode
}

const TrainingMaterialListItem: React.FC<TrainingMaterialListItemProps> = ({ children, disabled = false, item }) => {
  return (
    <ListItem key={item.Id} disableGutters>
      <ListItemText
        primary={item.Name}
        primaryTypographyProps={{
          variant: 'body2',
          fontWeight: 500,
          title: item.Name,
          noWrap: true,
        }}
        secondary={`Created ${moment(item.CreatedOn).calendar()}`}
      />

      <Box mr={2}>
        <TrainingMaterialLinkButton id={item.Id} disabled={disabled} />
      </Box>

      {children}
    </ListItem>
  )
}

export default memo(TrainingMaterialListItem)
